import React, { useState } from "react";
import HearingIcon from "@mui/icons-material/Hearing";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ExtensionIcon from "@mui/icons-material/Extension";
import MeaningMatchGame from "./MeaningMatchGame";
import LetterArrangeGame from "./LetterArrangeGame";
import "../styles/LetterArrange.css";

const TABS = [
  { id: "quiz",    label: "Quiz",    Icon: HearingIcon },
  { id: "meaning", label: "Meaning", Icon: MenuBookIcon },
  { id: "arrange", label: "Arrange", Icon: ExtensionIcon },
];

export default function GamesHub({ words, practiceType, kidName }) {
  const [tab, setTab] = useState("quiz");

  const hasMeanings = practiceType === "chinese"
    ? words.length > 0 && !!(words[0]?.english?.trim())
    : words.length > 0 && !!(words[0]?.meaningEn?.trim());

  return (
    <div className="games-hub">
      <div className="games-hub-tabs">
        {TABS.map(({ id, label, Icon }) => {
          const disabled = id === "meaning" && !hasMeanings;
          return (
            <button
              key={id}
              className={`games-hub-tab${tab === id ? " active" : ""}${disabled ? " disabled" : ""}`}
              onClick={() => !disabled && setTab(id)}
              disabled={disabled}
              title={disabled ? "No meanings available for this word list" : undefined}
            >
              <Icon style={{ fontSize: 18 }} />
              <span>{label}</span>
            </button>
          );
        })}
      </div>

      <div className="games-hub-content">
        {tab === "quiz" && (
          <MeaningMatchGame
            key="quiz"
            words={words}
            practiceType={practiceType}
            forcedMode="recognition"
          />
        )}
        {tab === "meaning" && (
          <MeaningMatchGame
            key="meaning"
            words={words}
            practiceType={practiceType}
            forcedMode="meaning"
          />
        )}
        {tab === "arrange" && (
          <LetterArrangeGame
            key="arrange"
            words={words}
            practiceType={practiceType}
            kidName={kidName}
          />
        )}
      </div>
    </div>
  );
}
